import { readPoolListByCode } from '@/api/asset/pool/read';
import { PoolListTableColumns } from '@/component/pools/table/ColumnsData';
import { Tables } from '@/component/pools/table/Tables';
import { ShortenAddr } from '@/lib/Shorten';
import { ResReadPoolListType } from '@/types';
import { Box, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import Header from '../Header';
import { isHideFilter, StateFilter } from '@/lib/filter/stakingPoolState';

export default function PoolListCmp({ type }: { type: 'list' | 'reward' }) {
  const [list, setList] = useState<ResReadPoolListType[]>([]);
  const url = type === 'list' ? '/pool-detail' : '/pool-reward';
  const title = type === 'list' ? '풀 리스트' : '풀 리워드 리스트';
  useEffect(() => {
    (async () => {
      const re = await readPoolListByCode();
      console.log(re);
      if (re.status !== 200) {
        return;
      }
      const list = re.data.map((item: ResReadPoolListType) => ({
        ...item,
        shortAddress: ShortenAddr(item.address),
        shortContractAddr: ShortenAddr(item.contractAddr),
        index: item.poolId,
        stateFilter: StateFilter(item.state),
        interestRate: Number(item.interestRate),
        isHideFilter: isHideFilter(item.isHide),
      }));
      setList(list);
    })();
    return () => {};
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title={title} />
        <Divider />
        <CardContent
          sx={{
            maxHeight: 1024, // 원하는 높이(px)로 조정
            overflow: 'auto',
          }}
        >
          {list && <Tables list={list} columns={PoolListTableColumns} navigateUrl={url} />}
        </CardContent>
      </Card>
    </Box>
  );
}
